/** @format */

import { Box } from '@mui/system';
import { Outlet } from 'react-router-dom';
import AdminNavBar from '../navigation/AdminNavBar';

function AdminLayout() {

  
  return (
    <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
      <AdminNavBar />
      <Box pb={2}></Box>

      <Box className='admin_layout_container'>
        <Outlet />
      </Box>
    </Box>
  );
}

export default AdminLayout;
